import React, { Component, ErrorInfo, ReactElement } from 'react'
import { Button, FadeIn } from 'lib/ui'
import { Container } from './styled'

interface Props {
  children: ReactElement
  layout: (props: { children: React.ReactElement }) => React.ReactElement
  onError?: (error: Error, errorInfo: ErrorInfo) => void
}

interface State {
  hasError: boolean
}

// https://reactjs.org/docs/error-boundaries.html
export class ErrorBoundary extends Component<Props, State> {
  state = {
    hasError: false
  }

  static getDerivedStateFromError (): State {
    return { hasError: true }
  }

  componentDidCatch (error: Error, errorInfo: ErrorInfo): void {
    this.props.onError?.(error, errorInfo)
  }

  render (): ReactElement {
    const { layout: LayoutComponent } = this.props
    if (this.state.hasError) {
      return (
        <LayoutComponent>
          <Container>
            <FadeIn>
              <div>
                <h2>
                  Oops, we are sorry!
                </h2>
                <p>
                  We just found a small error. If the problem persists please contact us.
                </p>
                <div>
                  <Button
                    onClick={() => window.location.reload()}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </FadeIn>
          </Container>
        </LayoutComponent>
      )
    }

    return this.props.children
  }
}
